import React from "react"
import styled from "@emotion/styled"
import { Flex, Box } from "@rebass/grid/emotion"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

const Wrapper = styled(Box)`
  @media (max-width: 1023px) {
    background: #e4e9e5;
    border-radius: 8px;
  }

  sup {
    font-size: 50%;
    top: -1em;
  }
`

const ResultsStats = ({ title, statsList }) => {
  return (
    <Wrapper p={[24, 24, 24, 0]} mt={[8, 8, 8, 0]}>
      <Box mb={[8, 8, 16, 8]}>
        <TextElementNova text={title} className="title " />
      </Box>
      <Flex>
        {statsList.map((stat, index) => {
          const isLast = index === statsList.length - 1
          return (
            <Box width={1 / 3} mr={!isLast ? ["10%", "10%", 80, 20, 40] : null}>
              <TextElementNova text={stat.number} className="stat-number" />
              <TextElementNova text={stat.copy} className="stat-copy " />
            </Box>
          )
        })}
      </Flex>
    </Wrapper>
  )
}

export default ResultsStats
